// extracted by mini-css-extract-plugin
module.exports = {"list":"FormsOverviewAudienceLinks_list__6iJCL","item":"FormsOverviewAudienceLinks_item___KsD0"};